import ManagePatientVision from "@components/ManagePatientVisionPage/ManagePatientVision"
import NavigationsPage from "@containers/NavigationsPage/NavigationPage"

const ManagePatientVisionPage = () => {
  return (
    <>
      <NavigationsPage>
        <ManagePatientVision />
      </NavigationsPage>
    </>
  )
}

export default ManagePatientVisionPage
